// extracted by mini-css-extract-plugin
export default {"OptionsWrapper":"OptionsWrapper_OptionsWrapper__RhtEo","SmallSize":"OptionsWrapper_SmallSize__Q0pQw"};